import { Pipe, PipeTransform } from '@angular/core';
import {
  formatBusinessNumber,
  formatContactNumber,
  formatAccountNumber,
} from '../helpers/formatters';

@Pipe({
  name: 'formatPhone',
  standalone: true,
})
export class FormatPhonePipe implements PipeTransform {
  transform(value: string | null | undefined, defaultValue = '-'): string {
    if (!value) return defaultValue;
    return formatContactNumber(value);
  }
}

@Pipe({
  name: 'formatBusinessNumber',
  standalone: true,
})
export class FormatBusinessNumberPipe implements PipeTransform {
  transform(value: string | null | undefined, defaultValue = '-'): string {
    if (!value) return defaultValue;
    return formatBusinessNumber(value);
  }
}

/**
 * 숫자를 천단위 콤마로 포맷 (예: 1234567 → "1,234,567")
 */
@Pipe({
  name: 'formatCurrency',
  standalone: true,
})
export class FormatCurrencyPipe implements PipeTransform {
  transform(
    value: number | string | null | undefined,
    suffix = '',
    defaultValue = '-'
  ): string {
    if (value === null || value === undefined || value === '') {
      return defaultValue;
    }
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return defaultValue;
    return num.toLocaleString('ko-KR') + suffix;
  }
}

@Pipe({
  name: 'formatAccount',
  standalone: true,
})
export class FormatAccountNumberPipe implements PipeTransform {
  transform(value: string | null | undefined, defaultValue = '-'): string {
    if (!value) return defaultValue;
    return formatAccountNumber(value);
  }
}
